export default __webpack_public_path__ + "static/media/Upholder Armguards.d2f21245.jpg";